function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { CheckMarkOutlineIcon, ClockOutlineIcon, CloseOutlineIcon, HourglassHalfOutlineIcon, NoStatusOutlineIcon } from '@applyboard/ui-icons';
import { match } from 'ts-pattern';
import { canPerformAction, canUpdateReqAttribute } from "../../utils/actions";
export function getRequirementStatusInfo(_ref) {
  var requirement = _ref.requirement;
  return match(requirement.status)["with"]('missing', function () {
    return {
      Icon: ClockOutlineIcon,
      intent: getRequirementStatusIntent(requirement)
    };
  })["with"]('preparing', function () {
    return {
      Icon: ClockOutlineIcon,
      intent: getRequirementStatusIntent(requirement)
    };
  })["with"]('reviewing', function () {
    return {
      Icon: HourglassHalfOutlineIcon,
      intent: getRequirementStatusIntent(requirement)
    };
  })["with"]('approved', function () {
    return {
      Icon: CheckMarkOutlineIcon,
      intent: 'positive'
    };
  })["with"]('rejected', function () {
    return {
      Icon: CloseOutlineIcon,
      intent: 'negative'
    };
  })["with"]('inactive', function () {
    return {
      Icon: NoStatusOutlineIcon,
      intent: 'secondary'
    };
  }).exhaustive();
}
function getRequirementStatusIntent(requirement) {
  if (requirement.status !== 'missing' && requirement.status !== 'reviewing' && requirement.status !== 'preparing') {
    return 'secondary';
  }
  return match(requirement.status)["with"]('missing', 'preparing', function () {
    if (canPerformAction(requirement, 'submit')) {
      return 'warning';
    }
    return 'secondary';
  })["with"]('reviewing', function () {
    if (canPerformAction(requirement, 'approve') || canPerformAction(requirement, 'reject') || canUpdateReqAttribute(requirement, 'answers.decisions')) {
      return 'warning';
    }
    return 'secondary';
  }).exhaustive();
}
export function simulateUnfulfillableRequirement(requirement) {
  var _requirement$availabl;
  var nonFulfillingActions = (_requirement$availabl = requirement.availableActions) === null || _requirement$availabl === void 0 ? void 0 : _requirement$availabl.filter(function (action) {
    return action.id !== 'submit' && action.id !== 'undo_submit';
  });
  return _objectSpread(_objectSpread({}, requirement), {}, {
    availableActions: nonFulfillingActions
  });
}
export function simulateApplicantRequirementView(requirement) {
  var _requirement$response;
  var modifiedAnswersHistory = requirement !== null && requirement !== void 0 && (_requirement$response = requirement.responses) !== null && _requirement$response !== void 0 && _requirement$response.answersHistory ? requirement.responses.answersHistory.map(function (history) {
    if (history.evaluatedBy === 'applyboard_automation') {
      return _objectSpread(_objectSpread({}, history), {}, {
        evaluatedBy: undefined
      });
    }
    return history;
  }) : undefined;
  return _objectSpread(_objectSpread(_objectSpread({}, requirement), {}, {
    internalTitle: null,
    internalDescription: null,
    flags: _objectSpread(_objectSpread({}, requirement.flags), {}, {
      manual: false,
      modified: false,
      applyboardRequirement: false
    })
  }, modifiedAnswersHistory && {
    responses: _objectSpread(_objectSpread({}, requirement.responses), {}, {
      answersHistory: modifiedAnswersHistory
    })
  }), {}, {
    availableActions: [{
      id: 'submit'
    }, requirement.status === 'reviewing' ? {
      id: 'undo_submit'
    } : undefined].filter(Boolean)
  });
}
export function getRequirementTitle(_ref2) {
  var requirement = _ref2.requirement;
  var internalTitle = requirement.internalTitle,
    requirementTemplateNumber = requirement.requirementTemplateNumber,
    title = requirement.title;
  if (!internalTitle) {
    return title;
  }
  return requirementTemplateNumber ? "".concat(requirementTemplateNumber, ": ").concat(internalTitle) : internalTitle;
}